import React from 'react'

interface Props {
  styleCssImage: string
}

const logoRecharge: React.FC<Props> = (
    {styleCssImage,
    }
) => {
  return (
    <svg
    className={`${styleCssImage} fill-[#FFC000]`}
    width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="59.9996" height="60" rx="10" />
      <path
        d="M36.3346 22.4791C36.2438 19.9818 35.9337 18.4688 34.8746 17.4116C33.3768 15.9166 30.9662 15.9166 26.1451 15.9166C21.324 15.9166 18.9134 15.9166 17.4157 17.4116C15.918 18.9066 15.918 21.3127 15.918 26.125V34.875C15.918 39.6872 15.918 42.0933 17.4157 43.5884C18.9134 45.0833 21.324 45.0833 26.1451 45.0833C30.9662 45.0833 33.3768 45.0833 34.8746 43.5884C35.9337 42.5311 36.2438 41.0182 36.3346 38.5208"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M24.668 40.7084H27.5846"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.332 30.4866V30.4997M42.2358 37.0497C43.9943 35.3703 45.082 33.05 45.082 30.4872C45.082 27.9244 43.9943 25.6042 42.2358 23.9247M39.2487 27.2059C40.1279 28.0456 40.6719 29.2057 40.6719 30.4872C40.6719 31.7686 40.1279 32.9287 39.2487 33.7684"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M21.75 15.9166L21.8798 16.6954C22.1611 18.3831 22.3017 19.2269 22.8805 19.7404C23.4842 20.2761 24.3402 20.2916 26.125 20.2916C27.9099 20.2916 28.7658 20.2761 29.3695 19.7404C29.9483 19.2269 30.0889 18.3831 30.3702 16.6954L30.5 15.9166"
        stroke="white"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M30.1484 33.6679C29.4508 34.9853 28.1814 35.8666 26.7313 35.8666C24.5295 35.8666 22.7446 33.8353 22.7446 31.3296V28.737C22.7446 26.2312 24.5295 24.2 26.7313 24.2C28.1814 24.2 29.4508 25.0812 30.1484 26.3987M21.3984 30.0333H27.1196"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default logoRecharge
